import { useDispatch } from 'react-redux';
import { nameTableRows } from '../constants/nameTableRso';
import {
  clearHighlightedColumns,
  setData,
  setHighlightedRows,
  setValueForm,
} from '../store/actions/rsoImportActions';

const useHandleHeaderLineChange = (form) => {
  const { setFieldsValue } = form || {};

  const dispatch = useDispatch();

  const handleHeaderLineChange = () => {
    dispatch(setValueForm({}));
    setFieldsValue({ [nameTableRows.firstRow]: '' });
    dispatch(setData([]));
    dispatch(clearHighlightedColumns());
    dispatch(setHighlightedRows(nameTableRows.firstRow, ''));
  };

  return handleHeaderLineChange;
};

export default useHandleHeaderLineChange;
